<template>
  <div id="help-login">
    <call />
    <!-- header -->
    <top-bar title="ヘルプ" backUrl="/help"/>
    <!-- main -->
    <main>
      <footer-app page="top" :loading="loading"></footer-app>
      <section>
        <div class="l-main--bg-border l-main--bg-border--pink">
          <div class="l-main__body">
            <div class="l-check-cart">
              <div class="l-check-cart__head min-h-100">
                <div class="l-check-cart__title text-left">アカウント連携</div>
                <div>
                  <router-link to="/help/login/description" class="c-btn-base c-btn--ct-left box-center mb-8">
                    アカウント連携すると利用できる機能
                  </router-link>
                  <router-link to="/help/login/detail" class="c-btn-base c-btn--ct-left box-center mb-8">
                    アカウント連携方法と連携解除方法
                  </router-link>
                  <router-link to="/help/login/apple" class="c-btn-base c-btn--ct-left box-center mb-8">
                    Appleアカウントでサインイン
                  </router-link>
                  <router-link to="/help/login/google" class="c-btn-base c-btn--ct-left box-center mb-8">
                    Googleアカウントでログイン
                  </router-link>
                  <router-link to="/help/login/line" class="c-btn-base c-btn--ct-left box-center mb-8">
                    LINEアカウントでログイン
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import Footer from "../components/Footer.vue";
import { Common } from "../common/common.js";
import { Tenant } from "../plugin/mixin.js";
import TopBar from "../components/TopBar.vue";

export default Vue.extend({
  name: "HelpLogin",
  components: {
    "footer-app": Footer,
    TopBar,
  },
  mixins: [Tenant],
  data() {
    return {
      loading: false,
    };
  },
  created() {
    this.init();
  },
  mounted() {
    Common.initDom();
  },
  methods: {
    async init() {
      Common.vueInitFunc(this);
      this.loading = false;
    },
  },
});
</script>